<template lang="pug">
.colorbar-careers-press
  section.press
    p.waves {{ title }}
    slick.pressQuotes(v-bind="quotesCarouselConfig" @beforeChange="handleQuoteChange")
      p(v-for="item in items" :key="item.quote") {{ item.quote }}
    
    .row
      slick.outlet(v-bind="iconsCarouselConfig")
        .icon-wrapper.xs-12-sm-12(v-for="(item, index) in items" :key="item.quote")
          .icon(v-html="item.svgIcon" :class="{hover: currentSlideIndex === index}")
</template>

<script>
  export default {

    name: 'HcbCareersPress',

    props: {
      title: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        default() {
          return [];
        }
      }
    },

    data() {
      return {
        currentSlideIndex: -1
      };
    },

    computed: {
      quotesCarouselConfig() {
        return {
          autoplay: true,
          slidesToShow: 1,
          fade: true,
          arrows: false
        };
      },

      iconsCarouselConfig() {
        return {
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: true,
          focusOnSelect: true,
          autoplay: true,
          responsive: [{
            breakpoint: 760,
            settings: {
              slidesToShow: 1,
              //centerMode: true,
              arrows: false,
            }
          }]
        };
      }
    },

    methods: {
      handleQuoteChange(currentSlide, nextSlide) {
        this.currentSlideIndex = nextSlide;
      }
    }
  };
</script>

<style lang="stylus" scoped>
.colorbar-careers-press
  overflow hidden

  .press
    padding 5.0625rem 0 3.796875rem

    p.waves
      font-family f-primary
      font-size 1.25rem
      line-height 30px
      color color-mister-darker-gray

      text-align center
      margin-bottom 1.5rem
      opacity 60
      padding 1rem

      @media mq-desktop-md-less
        font-size 18px

    .pressQuotes
      text-align center
      max-width 689px
      margin 0 auto 2.875rem
      p
        font-family f-primary
        font-size 1.875rem
        line-height 42px
        color #412738
        text-transform none

        padding 1rem

        @media mq-desktop-md-less
          font-size 24px

    .outlet
      :deep(.slick-track)
        display flex
        justify-content space-around
        align-items center

      :deep(.slick-list)
        padding 0px

      :deep(.slick-slide)
        @media mq-tablet-less
          width 100%
          height unset

    .icon
      width 100%

      :deep(svg)
        height unset !important
        width 90%
        margin-left 5%

    .hover
      .st0, .st1
        fill #735e73

</style>